import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../store';

@customElement('line-new-specsheet')
export class LineNewSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
		  :host {
			font-family: var(--font-family-light);
		  }
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
	}

	render() {
		return html`
			<specsheet-page>
				<page-summary></page-summary>
			</specsheet-page>
			<specsheet-page>
				<page-data-and-text></page-data-and-text>
			</specsheet-page>
			<specsheet-page>
				<page-diagram></page-diagram>
			</specsheet-page>
		`;
	}
}
